import React from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';

import { colors } from '@omilia/theme';
import {
  StyledDropdown,
  StyledDropdownContent,
} from 'components/HeaderDropdownMenu/styled';

export const SDropdown = styled(StyledDropdown)`
  &&& {
    .dropdown__trigger {
      align-items: center;
      display: flex;
      margin-right: 2px;
      padding: 3px 6px;

      :hover {
        background-color: ${rgba(colors.COLOR_WHITE, 0.1)};
        border-radius: 5px;
      }
    }
  }
`;

type DropDownContentWrapper = {
  isEnabled: boolean;
  children: React.ReactElement;
};
const DropDownContentWrapper = ({
  isEnabled,
  ...props
}: DropDownContentWrapper) => <StyledDropdownContent {...props} />;

export const SDropdownContent = styled(DropDownContentWrapper)`
  &&& {
    ${({ isEnabled }) => !isEnabled && 'width: 330px'};

    right: -14px;
    top: 27px;
  }
`;

export const SDivider = styled.hr`
  &&& {
    margin: 5px 0;
  }
`;
